// import SoundManager from './SoundManager.js';
import { QuizContents } from '../consts/TextContents.js';
export default class Boot extends Phaser.Scene {
    constructor() {
        super({
            key: 'Boot',
        });
    }
    init(data) {
        console.log('Boot init');

        const randomQuizContents = this.getRandomQuizContents(QuizContents);

        // Mécanique jeu classique
        // var startScene = 'Quiz';
        // Mécanique version quiz complet
        var startScene = 'Menu';
        var value = this.getUrlParam('scene', 'Empty');
        if (value != undefined && value != null && value != '' && value != 'Empty') {
            startScene = value;
        }

        var isMobile = /Mobi|Android/i.test(navigator.userAgent) || Phaser.Input.Touch.enabled;

        this.game.data = {
            sceneStopped: '',
            sceneRunning: '',
            Preloader: {
                next: startScene,
                sound: '',
            },
            isMobile: isMobile,
            level: 0,
            errorsCount: 0,
            quizContents: randomQuizContents,
            chronoDuration: 90,
            chronoText: '1:30',
            firstScreen: true,
            tutoOn: true,
            scaleX: 0.82,
            scaleY: 0.593,
            langue: 'ang',
        };
    }

    preload() {
        // Preloader
        // Charge les fichiers pour le preloader
        // this.TraductionManager.loadFile(this, 'assets/traductions.csv');

        this.load.on(
            'complete',
            function () {
                // console.log('Config langue :', this.game.data.langue);
                // if (this.game.data.langue == '' || this.game.data.langue == null) {
                //     this.game.data.langue = this.config.langue;
                // }
                // this.traductionManager.setLangue(this.game.data.langue);
                // this.traductionManager.init(this);
                this.scene.start('Preloader');
            },
            this,
        );
    }

    getUrlVars() {
        var vars = {};
        var parts = window.location.href.replace(
            /[?&]+([^=&]+)=([^&]*)/gi,
            function (m, key, value) {
                vars[key] = value;
            },
        );
        return vars;
    }

    getUrlParam(parameter, defaultvalue) {
        var urlparameter = defaultvalue;
        if (window.location.href.indexOf(parameter) > -1) {
            urlparameter = this.getUrlVars()[parameter];
        }
        return urlparameter;
    }
    getRandomQuizContents(quizContents) {
        // Mécanique jeu classique
        const shuffled = quizContents.sort(() => 0.5 - Math.random());
        return shuffled;

        // Mécanique version quiz complet
        // return quizContents
    }
}
